import * as v from "valibot";
import { baseVals, defineValidation } from "../../common/validation.common";

export namespace AssociateWagentValidation {
    export const SendMessage = defineValidation(
        v.object({
            phone: baseVals.phone(),
            message: baseVals.string(),
        }),
    );

    export const BroadcastMessage = defineValidation(
        v.object({
            title: baseVals.string(),
            message: baseVals.string(),
        }),
    );
}
